export default {
  'predictions.list.header.companies': 'Empresa',
  'predictions.list.header.creditor': 'Credor',
  'predictions.list.header.description': 'Descrição',
  'predictions.list.header.actions': 'Ações',
  
  
  'predictions.searchBar.create': 'Criar Nova Previsão',


  'predictions.form.company': 'Empresa',
  'predictions.form.creditor': 'Credor',
  'predictions.form.supplier': 'Fornecedor',
  'predictions.form.employee': 'Funcionário',
  'predictions.form.planAccount': 'Plano de Contas',
  'predictions.form.description': 'Descrição',
  'predictions.form.documentNumber': 'Número do Documento',
  'predictions.form.documentType': 'Tipo de Documento',
  'predictions.form.paymentDay': 'Dia Pagamento',
  'predictions.form.value': '(R$) Valor',
  };